export const userExists = '/user-history/user/exists';
export const userUpdateProfile = '/property/user/:id';
export const userChangePassword = '/property/user/set-new-password';
export const userResetPassword = '/property/user/change-password';
export const userValidateHash = '/user-history/validate-reset-password-hash';
export const userValidateHashFromInvite = '/user-history/user/find-by-hash';
export const userDetails = '/user-history/user/:id';
export const userApprove = '/property/team-member/approve';
export const userIntercomCredentials = '/personalization/intercom';
